function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_43_15)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.4048 8.81181L13.9974 13.3186L12.991 14.7026L10.4149 7.39937L19.6584 7.41498C19.7423 7.71793 19.8099 8.02521 19.8609 8.3355L19.8612 8.3373L19.8615 8.3391C19.956 8.88964 20.0023 9.44735 19.9999 10.0059V10.0081C19.9999 14.7901 16.5477 19.0364 11.6728 19.861C11.1105 19.9505 10.5422 19.997 9.97275 20.0001C8.13154 20.0018 6.32606 19.4919 4.75778 18.5274C3.33473 17.6522 2.15778 16.4339 1.33274 14.9876H2.93908C3.86561 16.2882 5.13421 17.3086 6.60568 17.9347C8.12683 18.5819 9.80135 18.7808 11.4318 18.5078L11.4332 18.5076C15.8371 17.7581 18.9489 13.7476 18.5981 9.30675L18.5599 8.8228L12.4048 8.81181Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.57987 12.5735L2.38847 12.5654H0.326588C0.25029 12.27 0.18901 11.9709 0.142998 11.6692L0.142335 11.6649L0.141598 11.6605C-0.779955 6.22966 2.89409 1.06134 8.32831 0.145952L8.33052 0.14557C10.4269 -0.216774 12.5843 0.101493 14.4867 1.05377C16.2352 1.92903 17.684 3.29763 18.657 4.98489H17.0332C16.1084 3.686 14.8416 2.66718 13.3721 2.04255C11.8529 1.3968 10.1806 1.19933 8.5528 1.47348L8.55191 1.47363C4.14898 2.2229 1.0268 6.2324 1.37773 10.6658L1.41603 11.1497L7.58979 11.1605L5.99321 6.65456L7.00899 5.26692L9.57987 12.5735Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_43_15"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

function SvgGlpCompounder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlpCompounder);
export default __webpack_public_path__ + "static/media/GLPCompounder.2049cf3836d42aca3b851a8d929e5f61.svg";
export { ForwardRef as ReactComponent };